




























































import { Component, Emit, Vue, Prop } from 'vue-property-decorator';
import {
  Representative,
  CustomTile,
  TaskDetailParam,
  ColumnSwitch,
  TaskChildViewAttributeGroup,
  TaskAttributeGroup,
} from '@/@types/LibraryComponent';
import TaskDetailModal from '@/components/taskList/taskDetailModal/TaskDetailModalBase.vue';
import TaskListTableHeader from '@/components/taskList/TaskListTableHeader.vue';
import TaskListTableBody from '@/components/taskList/TaskListTableBody.vue';
import EditableText from '@/components/common/EditableText.vue';
import EditableTextSchedule from '@/components/common/EditableTextSchedule.vue';
import EditableTextPerformance from '@/components/common/EditableTextPerformance.vue';
import TaskMinimizedList from '@/components/taskList/TaskMinimizedList.vue';
import AccountIcon from '@/components/common/AccountIcon.vue';
import CommonButton from '@/components/common/CommonButton.vue';
import DatePickerMenu from '@/components/taskList/taskListTableParts/DatePickerMenu.vue';
import PersonMenu from '@/components/taskList/taskListTableParts/PersonMenu.vue';
import SelectMenu from '@/components/taskList/taskListTableParts/SelectMenu.vue';
import AccentSelectMenu from '@/components/taskList/taskListTableParts/AccentSelectMenu.vue';
import { TasksType, FindTasksQuery } from '@/@types/Task';
import { UpdateModeQueryDto, UpdateMode } from '@/@types/Common';
import { vxm } from '@/store';
import { SelectTaskList, CustomAttribute } from '@/@types/LibraryComponent';

@Component({
  components: {
    TaskDetailModal,
    TaskListTableHeader,
    TaskListTableBody,
    EditableText,
    EditableTextSchedule,
    EditableTextPerformance,
    TaskMinimizedList,
    AccountIcon,
    CommonButton,
    DatePickerMenu,
    PersonMenu,
    SelectMenu,
    AccentSelectMenu,
  },
})
export default class TaskListTable extends Vue {
  /** 担当者、実施者などの一覧 */
  @Prop({ required: true, default: [] })
  private readonly representatives!: Representative[];
  // 優先度リスト
  @Prop()
  private priorities!: TaskAttributeGroup[];
  // カテゴリーリスト
  @Prop()
  private categories!: TaskAttributeGroup[];
  // ステータスリスト
  @Prop()
  private statuses!: TaskAttributeGroup[];
  @Prop()
  private customAttributes!: CustomAttribute[];
  @Prop()
  private customTiles!: CustomTile[];
  @Prop()
  private fieldColumns!: ColumnSwitch[];
  @Prop({ required: true })
  private taskChildViewAttributeGroups!: TaskChildViewAttributeGroup[];
  private isOpenTaskDetailModal: boolean = false;
  private allUpdateMode: UpdateModeQueryDto = {
    'update-mode': UpdateMode.all,
  };
  private partUpdateMode: UpdateModeQueryDto = {
    'update-mode': UpdateMode.part,
  };
  private findTasksQuery: FindTasksQuery = {
    'project-id': this.projectId,
  };
  private tasks: TasksType[] = [];

  /**
   * 表示中のタスク詳細モーダルを閉じる
   */
  private async closeTaskModal() {
    this.tasks.splice(0);
    this.isOpenTaskDetailModal = false;
    await vxm.theoryApi.tasksStore.fetchTasks({
      'project-id': this.projectId,
    });
  }

  /**
   * タスク詳細を開く
   */
  private openTaskModal(): void {
    // モーダルを開く
    this.isOpenTaskDetailModal = true;
  }

  private currentResponsiblePersonName(task: TasksType) {
    const currentResponsiblePerson = this.representatives.find((member) => {
      return member.accountId === task.currentResponsiblePersonId;
    });
    return currentResponsiblePerson
      ? currentResponsiblePerson.accountName
      : '担当者なし';
  }

  private practitionerName(task: TasksType) {
    const practitioner = this.representatives.find((member) => {
      return member.accountId === task.practitionerId;
    });
    return practitioner ? practitioner.accountName : '担当者なし';
  }

  private get tasksData(): TasksType[] {
    const response = vxm.theoryApi.tasksStore.getTasks;
    if (response) {
      return response.results;
    } else return [];
  }

  private get getTasks() {
    this.tasks = this.tasksData;
    return this.tasks;
  }

  private get projectId() {
    return vxm.theoryApi.authStore.getCurrentProjectId as number;
  }

  private get selectTaskList(): SelectTaskList[] {
    return this.tasksData.map((task) => {
      const selectTask: SelectTaskList = {
        taskId: task.taskId,
        taskName: task.taskName,
      };
      return selectTask;
    });
  }

  @Emit('emitTaskData')
  private emitTaskData(value: TaskDetailParam): TaskDetailParam {
    return value;
  }

  @Emit('emitCustomAttributeAddModal')
  private emitCustomAttributeAddModal() {
    return;
  }
}
